import React from 'react';
import VehicleItem from './VehiclesItem';
import CardWrapper from '../CardWrapper';

const VehicleComponent = (props) => {

    /**
     * vehicles: creates a list of vehilces
     */
    const vehicles = props.data.map((element, index) => {
        const vehicleName = `${element.make}/${element.model}/${element.year}`;
        return (
            <div key={index}>
                <VehicleItem
                    id={index}
                    {...element}
                    onVehicleClick={props.onVehicleClick}
                    name={vehicleName} />                
            </div>
        );
    });;

    //const vehicleCount = props.data.length;

    return (
        <CardWrapper>
            <div>
                <h3>
                    <i className="fa fa-car" aria-hidden="true" />
                    {' Vehicles '}
                    {/*
                        {'Found -'} {vehicleCount}
                     */}
                </h3>
                {vehicles}
            </div>
            <br/>
            <button className="btn btn-primary">
                Add a Vehicle
            </button>
        </CardWrapper>
    );
}

export default VehicleComponent;


// WEBPACK FOOTER //
// ./src/QuoteReview/vehicle/VehicleComponent.js